import { useCallback, useRef } from 'react'
import { useGetUserProfileData } from '../../../../hooks/casinoHooks/useUpdateUserProfileData'
import { useSetPlayerData } from '../../../store/playerStore/playerActions'
import { config } from '../../../../components/Init/Init'

export const useHandleFirebaseClientTags = () => {
  const { getProfileData } = useGetUserProfileData([config.playerProfileProperties.clientControls])
  const isFirstInit = useRef(false)
  const { setPlayerData } = useSetPlayerData()

  function mergePlayerTags(existingTags, newTag = null) {
    if (!newTag) {
      return existingTags
    }

    const validJsonString = existingTags.replace(/'/g, '"')
    const arrayObject = JSON.parse(validJsonString)

    arrayObject.push(newTag)

    return JSON.stringify(arrayObject).replace(/"/g, "'")
  }

  const handleFirebaseClientTags = useCallback(
    (db, playerId) => {
      db.ref(`users/${playerId}/tagsToRefresh`).on('value', async snapshot => {
        const snapshotVal = snapshot.val()
        if (snapshotVal && isFirstInit.current) {
          // get actual player profile data
          const profileData = await getProfileData()
          const { tagsBanner, tagsInbox } = profileData.data.client_controls

          if (snapshotVal.bannerTag) {
            const newTagsBanner = mergePlayerTags(tagsBanner, snapshotVal.bannerTag.toString())

            setPlayerData({
              tagsBanner: newTagsBanner
            })
          }

          if (snapshotVal.inboxTag) {
            const newInboxTag = mergePlayerTags(tagsInbox, snapshotVal.inboxTag.toString())

            setPlayerData({
              tagsInbox: newInboxTag
            })
          }
        } else {
          isFirstInit.current = true
        }
      })
    },
    [getProfileData, setPlayerData]
  )

  return { handleFirebaseClientTags }
}
